<CustomerEngagements {customer} showFilters={false} />

<script lang="ts">
  import CustomerEngagements from '../../customer_engagements/Table.svelte'

  export let customer
</script>
